import { useAtomValue } from 'jotai';
import { WifiSlash } from '@phosphor-icons/react';
import { serviceUnavailableAtom } from '@/state/atoms';
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogMedia,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogAction,
} from '@/components/ui/alert-dialog';

export function OfflineCheck() {
  const isUnavailable = useAtomValue(serviceUnavailableAtom);

  return (
    <AlertDialog open={isUnavailable}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogMedia>
            <WifiSlash />
          </AlertDialogMedia>
          <AlertDialogTitle>Service Unavailable</AlertDialogTitle>
          <AlertDialogDescription>
            We're having trouble connecting to the server. This is usually
            temporary — please check back in a moment.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction onClick={() => window.location.reload()}>
            Retry
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
